import React, { Fragment, useState } from "react";

import Approve from "./Approve";
import LifeformInfo from "./LifeformInfo";
import { useReadContract } from "wagmi";
import { LifeformsConfig, CharonConfig } from "../services/web3";
import translate from "../services/translate";

const BridgeMint = ({ id, userAddress, setMinted }) => {
  const [approved, setApproved] = useState(false);
  const [minted] = useState(false);

  const approvals = useReadContract({
    ...LifeformsConfig,
    functionName: 'getApproved',
    args: [id],
  })

  const approvedForAll = useReadContract({
    ...LifeformsConfig,
    functionName: 'isApprovedForAll',
    args: [userAddress, CharonConfig.address],
  })

  return (
    <Fragment>
    {(approvals.data && approvals.data === CharonConfig.address) || approvedForAll.data || approved ? (
      minted ? (
        <div className="panelwide"></div>
      ) : (
      <LifeformInfo tokenId={id} address={userAddress} setMinted={setMinted}/>
      )
    ) : (
        <div className="panel">
        <div className="panelContents">
          <p>Good Death</p> 
            <p>{translate("BridgeMint.para1")}</p>
            <p>{translate("BridgeMint.para2")}</p>
            <p>{translate("BridgeMint.para3")}</p>
            <p>{translate("BridgeMint.para4")}</p>
            <Approve tokenId={id} setApproved={setApproved} />
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default BridgeMint;
